import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { MinimalHeader } from './MinimalHeader';
import { Footer } from './Footer';

export const ResponsiveLayout: React.FC = () => {
  const location = useLocation();
  
  // Páginas que não devem ter header
  const hideHeader = location.pathname === '/assessment';

  if (hideHeader) {
    // Para páginas como assessment, usar layout simples
    return (
      <div className="min-h-screen bg-slate-50">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-50 via-white to-accent-50">
      <MinimalHeader />
      <div className="pt-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
};